import React from "react";
import { STATUS_LABEL, STATUS_TONE } from "@/lib/api";

export function StatusPill({ status }) {
  const tone = STATUS_TONE[status] || "default";
  return (
    <span className="bc-status" data-tone={tone} data-testid={`status-${status}`}>
      <span className="signal-dot" style={{ background: "currentColor", opacity: 0.7 }} />
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function KatlasStatusPill({ status, label }) {
  const tone =
    status === "active"
      ? "success"
      : status === "auth_rejected" || status === "node_error"
      ? "danger"
      : status === "unreachable"
      ? "warn"
      : "default";
  return (
    <span className="bc-status" data-tone={tone} data-testid={`katlas-status-${status}`}>
      <span className="signal-dot" style={{ background: "currentColor" }} />
      {label || status}
    </span>
  );
}

export function Tag({ children, tone }) {
  return (
    <span className="bc-status" data-tone={tone || "default"}>
      {children}
    </span>
  );
}
